export function setSymbol(state, symbol) {
  state.chartSymbol = symbol;
}
export function setActiveIndicators(state, indicators) {
  state.activeIndicators = indicators;
}
export function setTvWidget(state, tvWidget) {
  state.tvWidget = tvWidget;
}
